"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Person_Link = exports.Person_LinkAssuranceKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Element_1 = require("./RTTI_Element");
var Person_LinkAssuranceKind;
(function (Person_LinkAssuranceKind) {
    Person_LinkAssuranceKind["_level1"] = "level1";
    Person_LinkAssuranceKind["_level2"] = "level2";
    Person_LinkAssuranceKind["_level3"] = "level3";
    Person_LinkAssuranceKind["_level4"] = "level4";
})(Person_LinkAssuranceKind = exports.Person_LinkAssuranceKind || (exports.Person_LinkAssuranceKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Person_Link = t.recursion('IPerson_Link', function () {
    return t.intersection([
        t.type({
            target: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            assurance: (0, EnumType_1.createEnumType)(Person_LinkAssuranceKind, 'Person_LinkAssuranceKind'),
            _assurance: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_Person_Link.js.map